import { find, get } from "lodash";
import React, { Component } from "react";
import Loadable from "react-loadable";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { partnerInfo } from "~/configs/partnerDetails";
import { selectFee } from "~/store/fee/feeActions";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const PaymentConfirmInformationPageDesktop = Loadable({
  loader: () =>
    import(/* desktop */ "~/components/desktop/pages/FeeResultSearch"),
  loading: LoadableLoading
});

class DetectPaymentConfirmInformation extends Component {
  methods = {
    handleSelectFee: fee => {
      this.props.selectFee(fee);
      this.props.history.push("/hinh-thuc-thanh-toan-vien-phi");
    },
    handleGoBack: () => {
      const { history } = this.props;
      history.push("/tim-ma-thanh-toan-vien-phi");
    }
  };

  render() {
    return (
      <React.Fragment>
        <PaymentConfirmInformationPageDesktop
          {...this.props}
          {...this.methods}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    fee: { listFee, patient }
  } = state;
  return {
    device: type,
    listFee,
    patient
  };
};

const PaymentConfirmInformationHelmet = withTitle({
  component: DetectPaymentConfirmInformation,
  title: `${hospitalName.value} | Xác nhận thông tin thanh toán`
});

export default connect(mapStateToProps, { selectFee })(
  withRouter(PaymentConfirmInformationHelmet)
);
